import { useCallback } from 'react';

import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';

import { useBreakpoints } from '#client/pages/EducationStudio/hooks/useBreakpoints';

import { useLessonStorage } from '../../../hooks';
import { ExercisePage, MAX_CHARACTER_COUNT } from '../../Interactive/WorksheetActivity/exercisePage';
import {
  StyledImageContainer,
  StyledNextButton,
  StyledSharedAsset,
  StyledText,
  StyledTextArea,
  StyledUserInputText
} from '../../Interactive/WorksheetActivity/useStyles';
import { THE_WORLD_NEEDS } from './whatTheWorldNeeds';
import { I_CAN_GET_PAID_FOR } from './whatYouCanGetPaidFor';

const NEXT_BUTTON_TEXT = 'Next';
export const MY_VOCATION_IS = 'myVocationIs';

export const YourVocation = ({ onNext }) => {
  const { lesson } = useParams();
  const { getStorageValue, setStorageValue, saveChanges } = useLessonStorage(lesson);
  const {
    sizes: { isMobile }
  } = useBreakpoints();

  const onNextHandler = useCallback(() => {
    saveChanges();
    onNext();
  }, [saveChanges, onNext]);

  const presentation = (
    <StyledImageContainer>
      <StyledSharedAsset
        src="/journey%20to%20success/01%20MVE%20Series/01%20PEAKS/mve_peaks_exercise7.svg"
        alt="ikigai-exercise"
        width={500}
      />
    </StyledImageContainer>
  );
  const summary = <StyledText size="lg">What the world needs and what you can get paid for.</StyledText>;

  return (
    <ExercisePage
      caption="Exercise"
      title="Your vocation &#128188;"
      summary={summary}
      presentation={presentation}
      buttonText={NEXT_BUTTON_TEXT}
      isButtonDisabled={!getStorageValue(MY_VOCATION_IS)}
      onNext={onNextHandler}
    >
      <StyledUserInputText
        size={isMobile ? 'lg' : 'xl'}
        color="wisdom40"
      >
        &#127758;
        {' '}
        <strong>The world needs</strong>
        {' '}
        {getStorageValue(THE_WORLD_NEEDS)}
      </StyledUserInputText>
      <StyledText
        size={isMobile ? 'lg' : 'xl'}
        color="wisdom40"
      >
        &#128181;
        {' '}
        <strong>I can get paid for</strong>
        {' '}
        {getStorageValue(I_CAN_GET_PAID_FOR)}
      </StyledText>
      <StyledTextArea
        placeholder="My vocation is..."
        text={getStorageValue(MY_VOCATION_IS)}
        onChangeHandler={(e) => setStorageValue(MY_VOCATION_IS, e.target.value)}
        maxLength={MAX_CHARACTER_COUNT}
      />
      {!isMobile && (
      <StyledNextButton
        className="buttonRight"
        variant="contained"
        color="primary"
        size="large"
        disabled={!getStorageValue(MY_VOCATION_IS)}
        onClick={() => onNextHandler()}
      >
        {NEXT_BUTTON_TEXT}
      </StyledNextButton>
      )}
    </ExercisePage>
  );
};

YourVocation.propTypes = {
  onNext: PropTypes.func
};

YourVocation.defaultProps = {
  onNext: () => {}
};

export default YourVocation;
